import {useState} from 'react';
// import { Link } from 'react-router-dom';
import { Link } from '@mui/material';
import './Sections.css';
import logo from '../../../assets/images/logo.png';
import TermsOfUseModal from '../../../pages/dashboard/components/terms_of_use';
import { WATERMARK_CONFIG } from '../../../common/utility/constant';




const FooterSection = () => {
  const [openModal,setOpenModal]=useState(false);
  const [contactInfo,setContactInfo]=useState(false);


    const openContactInfoModal=()=>{
        setOpenModal(true);
        setContactInfo(true);
    }
  
  const closeModal = () => {
    setOpenModal(false);
  }




  return (
    <footer className="footer-section">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="footer-logo">
              <img src={logo} alt="Vtrender™ Logo" />
            </div>
            <p className="footer-tagline">
              Advanced market analysis tools for modern traders
            </p>
            <div className="social-links">
              <a href="https://x.com/Vtrendercharts" target="_blank" rel="noopener noreferrer">
                <img width="48" height="48" src="https://img.icons8.com/color/48/twitterx--v1.png" alt="twitterx--v1"/>
              </a>
              <a href="https://www.youtube.com/@Vtrender" target="_blank" rel="noopener noreferrer">
                <img width="48" height="48" src="https://img.icons8.com/color/48/youtube-play.png" alt="youtube-play"/>
              </a>
              <a href="https://www.instagram.com/vtrendercharts/" target="_blank" rel="noopener noreferrer">
                <img width="48" height="48" src="https://img.icons8.com/color/48/instagram-new--v1.png" alt="instagram-new--v1"/>
              </a>
            </div>
          </div>
          
          <div className="footer-links">
            <div className="footer-links-column">
              <h4>Product</h4>
              <ul>
                <li><Link sx={{ml:0, cursor:"pointer"}} onClick={() => {
                  document.getElementById('feature-grid-section').scrollIntoView({ 
                    behavior: 'smooth' 
                  });
                }}>
                  Features</Link></li>
                <li><Link sx={{ml:0, cursor:"pointer"}} href="/pricing">Pricing</Link></li>
                <li><Link sx={{ml:0, cursor:"pointer"}} href="/faqs">FAQs</Link></li>
                <li><Link sx={{ml:0, cursor:"pointer"}} href="/glossary">Glossary</Link></li>
              </ul>
            </div>
            
            <div className="footer-links-column">
              <h4>Resources</h4>
              <ul>
                <li><Link sx={{ml:0, cursor:"pointer"}} href="/info-manual">User Manual</Link></li>
                <li><Link sx={{ml:0, cursor:"pointer"}} href="/intro-manual">Getting Started</Link></li>
                <li><Link sx={{ml:0, cursor:"pointer"}} href="/blogs">Blogs</Link></li>
                <li><Link sx={{ml:0, cursor:"pointer"}} href="/help">Support</Link></li>
              </ul>
            </div>
            
            <div className="footer-links-column">
              <h4>Company</h4>
              <ul>
                <li><Link sx={{ml:0, cursor:"pointer"}} href="/about-us">About Us</Link></li>
                <li><Link sx={{ml:0, cursor:"pointer"}} onClick={openContactInfoModal}>Contact</Link></li>
                <li><Link href="/careers">Careers</Link></li>
              </ul>
            </div>
            
            <div className="footer-links-column">
              <h4>Legal</h4>
              <ul>
                <li><Link sx={{ml:0, cursor:"pointer"}} href="/privacy-policy#terms-of-service">Terms of Service</Link></li>
                <li><Link sx={{ml:0, cursor:"pointer"}} href="/privacy-policy#privacy-policy">Privacy Policy</Link></li>
                <li><Link sx={{ml:0, cursor:"pointer"}} href="/privacy-policy#refund-policy">Refund Policy</Link></li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p className="copyright">
            {WATERMARK_CONFIG.TEXT}
          </p>
        </div>
      </div>
      {openModal?
        <TermsOfUseModal closeModal={closeModal} contactInfo={contactInfo}></TermsOfUseModal>
          : 
    <></>}
    </footer>
  );
};

export default FooterSection;
